import React from 'react'

interface Props {
    size: 'large' | 'medium' | 'small'
    children: React.ReactNode
    className?: string,    
}

export const Heading: React.FC<Props> = ({ size, className, children }) => {

    const baseClass = 'membership-app__heading'
    
    let classNames = [
        `${baseClass}`,
        `${baseClass}--${size}`
    ]

    if ( className ) {
        classNames.push(className)
    }

    const classes = classNames.join(' ')

    if ( size === 'large' ) {
        return <h2 className={classes}>{children}</h2>
    }

    if (size === 'medium') {
        return <h3 className={classes}>{children}</h3>
    }

    if ( size === 'small' ) {
        return <h4 className={classes}>{children}</h4>
    }

    return <span className={classes}>{children}</span>
}